import { Outlet } from "react-router-dom";
import { WebNavBar } from "../Output/WebNavBar";
import { WebNavFooter } from "../Output/WebNavFooter";

import { DrawerStateProvider } from "../Trays/DrawerStateProvider";
import Drawer, { DrawerSlideEnum } from "../Trays/Drawer";
import Account from "../Trays/Account";

import { ModalStateProvider } from "../Modal/ModalStateProvider";
import ModalContainer from "../Modal/ModalContainer";
import { SwipeProvider } from "../Gestures/SwipeProvider";
import { SnackbarProvider } from "../Snackbars/SnackbarProvider";
import { SeoOptimizer } from "../../Analytics/SeoOptimizer ";
import { GoogleTag } from "../../Analytics/GoogleTag";

export function DesktopWebsite() {
	return (
		<SwipeProvider>
			<SeoOptimizer />
			<GoogleTag />
			<DrawerStateProvider>
				<ModalStateProvider>
					<SnackbarProvider>
						{/* DesktopTemplate inlined */}
						<div className="min-h-screen min-w-screen flex bg-primary-background text-primary">
							<div className="flex-1 flex flex-col">
								{/* Main content area */}
								<div className="flex-1">
									<div className="flex flex-row items-center justify-center bg-primary-background text-primary">
										<div className="min-w-4"></div>
										<div className="flex-1 flex flex-col pt-4 space-y-4">
											<WebNavBar />
											<div className="flex-1">
												<Outlet />
											</div>
										</div>
										<div className="min-w-4"></div>
									</div>
								</div>

								{/* Footer at bottom */}
								<WebNavFooter showContour={true} showLinks={true} />
							</div>
						</div>
						<Drawer position={DrawerSlideEnum.Left}>
							<Account />
						</Drawer>
						<ModalContainer />
					</SnackbarProvider>
				</ModalStateProvider>
			</DrawerStateProvider>
		</SwipeProvider>
	);
}
